import React from 'react';
import { Box, LinearProgress } from '@mui/material';

const PageLoader: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        width: '100%',
        mb: 2,
      }}
    >
      <LinearProgress
        sx={{
          height: 3,
          borderRadius: 999,
          backgroundColor: 'rgba(30, 64, 175, 0.12)',
          '& .MuiLinearProgress-bar': {
            borderRadius: 999,
          },
        }}
      />
    </Box>
  );
};

export default PageLoader;